"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.distribution = exports.initialState = void 0;
const monocle = require("monocle-ts");
const fp = require("fp-ts");
const addressBook = require("./addressBook");
const wizard = require("./wizard");
const _newExternalUser = require("../../modules/newExternalUser/reducers");
const _deliveryMethods = require("../../modules/deliveryMethods/reducers");
const _finishings = require("../../modules/finishings/reducers");
const _printProviders = require("../../modules/printProviders/reducers");
const recipients = require("./recipients");
const list = require("./list");
const newExternalUser = _newExternalUser.default('distribution');
const deliveryMethods = _deliveryMethods.default('distribution');
const finishings = _finishings.default('distribution');
const printProviders = _printProviders.default('distribution');
//#endregion
//#region INITIAL STATE
exports.initialState = {
    wizard: Object.assign({}, wizard.initialState),
    recipients: Object.assign({}, recipients.initialState),
    addressBook: Object.assign({}, addressBook.initialState),
    newExternalUser: Object.assign({}, newExternalUser.initialState),
    list: Object.assign({}, list.initialState),
    finishings: Object.assign({}, finishings.initialState),
    deliveryMethods: Object.assign({}, deliveryMethods.initialState),
    printProviders: Object.assign({}, printProviders.initialState)
};
//#endregion
//#region LENS
const wizardLens = monocle.Lens.fromProp('wizard');
const listLens = monocle.Lens.fromProp('list');
const newExternalUserLens = monocle.Lens.fromProp('newExternalUser');
const recipientsLens = monocle.Lens.fromProp('recipients');
const addressBookLens = monocle.Lens.fromProp('addressBook');
const finishingsLens = monocle.Lens.fromProp('finishings');
const deliveryMethodsLens = monocle.Lens.fromProp('deliveryMethods');
const printProvidersLens = monocle.Lens.fromProp('printProviders');
//#endregion
//#region REDUCER
// Address book
const handleAddressBook = (action) => (state) => {
    const fn = addressBook.methods[action.type];
    if (fn) {
        return addressBookLens.modify((cState) => fn(cState, action))(state);
    }
    return state;
};
// Delivery Methods
const handleDeliveryMethods = (action) => (state) => {
    const fn = deliveryMethods.methods[action.type];
    if (fn) {
        return deliveryMethodsLens.modify((cState) => fn(cState, action))(state);
    }
    return state;
};
// Finishings
const handleFinishings = (action) => (state) => {
    const fn = finishings.methods[action.type];
    if (fn) {
        return finishingsLens.modify((cState) => fn(cState, action))(state);
    }
    return state;
};
// Add new Recipient
const handleNewRecipients = (action) => (state) => {
    const fn = newExternalUser.methods[action.type];
    if (fn) {
        return newExternalUserLens.modify((cState) => fn(cState, action))(state);
    }
    return state;
};
// Delivery Methods
const handlePrintProviders = (action) => (state) => {
    const fn = printProviders.methods[action.type];
    if (fn) {
        return printProvidersLens.modify((cState) => fn(cState, action))(state);
    }
    return state;
};
// Recipients
const handleRecipients = (action) => (state) => {
    const fn = recipients.methods[action.type];
    if (fn) {
        return recipientsLens.modify((cState) => fn(cState, action))(state);
    }
    return state;
};
const handleList = (action) => (state) => {
    const fn = list.methods[action.type];
    if (fn) {
        const list = listLens.get(state);
        return listLens.set(fn(list, action))(state);
    }
    return state;
};
const handleWizard = (action) => (state) => {
    const fn = wizard.methods[action.type];
    if (fn) {
        const wizard = wizardLens.get(state);
        return wizardLens.set(fn(wizard, action))(state);
    }
    return state;
};
const distribution = (state = exports.initialState, action) => {
    return fp.function.compose(handleList(action), handleWizard(action), handleAddressBook(action), handleDeliveryMethods(action), handleFinishings(action), handleNewRecipients(action), handlePrintProviders(action), handleRecipients(action))(state);
};
exports.distribution = distribution;
//#endregion
//# sourceMappingURL=index.js.map